export class IncorrectCardExternalIdError extends Error {
  constructor() {
    super('Card externalId is missing or invalid');
    this.name = 'IncorrectCardExternalIdError';
  }
}
